export default {
    colors: {
        background: {
            default: `#000000`,
            tertiary: `#0e0e0e`,
            secondary: `#0e0e0e`
            // default: `#FFFFFF`,
            // tertiary: `#DAE3E5`,
            // secondary: `#BBD1EA`
        },
        border: {
            secondary: `#a0c1dd`,
            tertiary: `#d8e8ef`
            // secondary: `#a0c1dd`,
            // tertiary: `#cedce4`
        },
        brand: {
            primary: `#ffb71b`,
            secondary: `#108e45`
        },
        text: {
            default: `#d0d0d0`,
            muted: `#66788A`,
            dark: `#234361`
        },
        fixed: {
            white: `#000000`
        },
        danger: `#FC5130`
    },
    responsive: {
        desktop: `@media (min-width: 770px)`,
        device: `@media (min-width: 320px) and (max-width: 769px)`,
        sff: `@media (max-width: 479px)`
    }
};
